import { fromJS } from 'immutable';
import { Types } from './actions';

const initialState = fromJS({
  loading: false,
  error: null,
  success: false,
});

const mfaVerificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SUBMIT_MFA:
      return state.merge({ loading: true, error: null, success: false });
    case Types.SUBMIT_MFA_SUCCESS:
      return state.merge({ loading: false, error: null, success: true });
    case Types.SUBMIT_MFA_FAIL:
      return state.merge({ loading: false, error: action.error, success: false });
    case Types.RESET_MFA:
      return initialState;
    default:
      return state;
  }
};

export default mfaVerificationReducer;
